// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__30djY","list":"PatternAutocomplete_list__20KPs"};